import { Redirect, Route, Switch } from "react-router-dom";
import {
  BULK_IMPORTS_ROOT_PATH,
  PATH_IMPORT_CONTRACTORS_BATCH,
  PATH_IMPORT_CONTRACTORS_BATCH_HISTORY,
  PATH_IMPORT_CONTRACTORS_START,
  PATH_IMPORT_PAYABLES_BATCH,
  PATH_IMPORT_PAYABLES_BATCH_HISTORY,
  PATH_IMPORT_PAYABLES_START
} from "./paths";
import { RouteImportPayableBatchDetails } from "./routes/RouteImportPayableBatchDetails";
import { RouteImportPayableBatchEventHistory } from "./routes/RouteImportPayableBatchEventHistory";
import { RouteImportPayablesStart } from "./routes/RouteImportPayablesStart";
import { RouteImportContractorsBatchDetails } from "./routes/RouteImportContractorsBatchDetails";
import { RouteImportContractorBatchEventHistory } from "./routes/RouteImportContractorBatchEventHistory";
import { RouteImportContractorsStart } from "./routes/RouteImportContractorsStart";
import { BulkImports } from "./routes/BulkImports";

export const BulkImportsIndex: React.FC = () => (
  <Switch>
    {/* Bulk import contractors pages */}
    <Route
      path={PATH_IMPORT_CONTRACTORS_START}
      component={RouteImportContractorsStart}
    />
    <Route
      path={PATH_IMPORT_CONTRACTORS_BATCH_HISTORY}
      component={RouteImportContractorBatchEventHistory}
    />
    <Route
      path={PATH_IMPORT_CONTRACTORS_BATCH}
      component={RouteImportContractorsBatchDetails}
    />
    {/* Bulk import payables pages */}
    <Route
      path={PATH_IMPORT_PAYABLES_START}
      component={RouteImportPayablesStart}
    />
    <Route
      path={PATH_IMPORT_PAYABLES_BATCH_HISTORY}
      component={RouteImportPayableBatchEventHistory}
    />
    <Route
      path={PATH_IMPORT_PAYABLES_BATCH}
      component={RouteImportPayableBatchDetails}
    />
    <Route path={BULK_IMPORTS_ROOT_PATH} component={BulkImports} />
    <Redirect from="*" to={BULK_IMPORTS_ROOT_PATH} />
  </Switch>
);
